import { useEffect, useState } from 'react'

/**
 * Custom hook to check the network state of the browser
 */
const useNetworkState = () => {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine)
  const [hasRestoredConnection, setHasRestoredConnection] = useState<boolean | null>(!window.navigator.onLine ? false : null)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      if (hasRestoredConnection === false) {
        setHasRestoredConnection(true)
      }
    }
    const handleOffline = () => {
      setIsOnline(false)
      setHasRestoredConnection(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [hasRestoredConnection])

  return { isOnline, restoredConnection: hasRestoredConnection }
}

export default useNetworkState
